<template>
	<v-container>
		<v-card v-if="page">
			<v-card v-if="isLoading" class="text-xs-center">
				<v-container>
					<v-progress-circular
						:size="70"
						:width="7"
						color="primary"
						indeterminate
					></v-progress-circular>
				</v-container>
			</v-card>
			<v-container v-else>
				<v-form v-model="valid" ref="form" lazy-validation class="mb-4">
					<h2 class="display-1 mb-4">{{ page.title }}</h2>
					<p
						v-for="(paragraph, key) in page.paragraphs"
						:key="key"
						class="body-1"
					>
						{{ paragraph }}
					</p>
					<p>* Pflichtfelder</p>
					<v-text-field
						label="E-Mail-Adresse *"
						v-model="params.email"
						:rules="emailRules"
						class="mb-2"
						required
					></v-text-field>
					<!-- <swatches
						v-model="params.color"
						colors="material-basic"
						row-length="10"
						swatch-size="24"
					>
						<v-text-field
							slot="trigger"
							:value="params.color"
							label="Farbe"
						></v-text-field>
					</swatches> -->
					<v-text-field
						label="Farbe (als Hex-Code)"
						v-model="params.color"
						:rules="hexRules"
						class="mb-2"
						required
					></v-text-field>
					<v-text-field
						label="URL-Titelbild (900x400px)"
						v-model="params.title_img"
						:rules="titleImgRules"
						class="mb-2"
						required
					></v-text-field>
					<v-text-field
						label="URL-Datenschutzerklärung *"
						v-model="params.privacy_url"
						:rules="urlRules"
						class="mb-2"
						required
					></v-text-field>
					<v-text-field
						label="E-Mail-Adresse Datenschutz-Kontakt"
						v-model="params.privacy_email"
						:rules="privacyEmailRules"
						class="mb-2"
						required
					></v-text-field>
					<v-text-field
						label="Google Tag Manager ID"
						v-model="params.gtm"
						class="mb-2"
						required
					></v-text-field>
					<v-text-field
						label="IntelliAd Tracking Pixel ID"
						v-model="params.tracking"
						class="mb-2"
						required
					></v-text-field>
					<v-btn @click="submit" color="primary">Code generieren</v-btn>
				</v-form>
				<v-container v-if="isGenerating" class="text-xs-center">
					<v-progress-circular
						:size="35"
						:width="7"
						color="primary"
						indeterminate
					></v-progress-circular>
				</v-container>
				<v-textarea
					v-if="code"
					box
					name="input-7-4"
					label="Einbett Code"
					readonly
					:value="code"
				></v-textarea>
			</v-container>
		</v-card>
	</v-container>
</template>

<script>
import { mapState } from 'vuex';
// import Swatches from 'vue-swatches';
// import 'vue-swatches/dist/vue-swatches.min.css';

export default {
	// components: {
	// 	Swatches,
	// },
	computed: {
		...mapState({
			page: 'page',
			code: 'embedCode',
			isLoading: 'isLoading',
			isGenerating: 'isGenerating',
		}),
	},
	methods: {
		submit() {
			const isValid = this.$refs.form.validate();

			if (isValid) {
				this.$store.dispatch('generateCode', this.params);
			}
		},
	},
	created() {
		this.$store.dispatch('getPage', 1000);
	},
	data: () => ({
		valid: false,
		params: {
			color: '#3E9487',
			email: '',
			title_img: '',
			privacy_url: '',
			privacy_email: '',
			gtm: '',
			tracking: '',
		},
		emailRules: [
			v => !!v || 'Bitte geben Sie eine Email-Adresse an',
			v => /.+@.+/.test(v) || 'Bitte geben Sie eine gültige Email-Adresse an',
		],
		urlRules: [
			v => !!v || 'Bitte geben Sie eine Datenschutzerklärung-URL an',
			v => /http/.test(v) || 'Bitte geben Sie einen validen Link an',
		],
		privacyEmailRules: [
			v =>
				!v ||
				/.+@.+/.test(v) ||
				'Bitte geben Sie eine gültige Email-Adresse an',
		],
		titleImgRules: [
			v => !v || /http/.test(v) || 'Bitte geben Sie einen validen Link an',
		],
		hexRules: [
			v =>
				!v ||
				/^#([0-9A-F]{3}){1,2}$/i.test(v) ||
				'Bitte geben Sie einen validen Hex-Code an',
		],
	}),
};
</script>
